<sd-html [html]="textKey | translate: {
  siteBrand: data.siteBrand | titlecase,
  brandCorner: data.brand | titlecase,
  itemName: data.itemName,
  website: data.website
}" />

<button sd-button
  [brand]="brand"
  icon="icon-cross"
  class="c__close-button"
  [isSmall]="true"
  [isIcon]="true"
  [theme]="buttonTheme"
  (click)="close()"
>
  <span class="is-visually-hidden">{{ 'actions.close' | translate }}</span>
</button>
